import type { TEmailBuilderActivePanel } from "redux/reducers/emailBuilder/emailBuilder";

export const EMAIL_BUILDER_PANEL_SHEET_EXPANDED_SNAP_POINT = 0.92;

export const EMAIL_BUILDER_NAV_SHEET_SNAP_POINTS = [0.45];
export const EMAIL_BUILDER_NAV_SHEET_DEFAULT_SNAP_POINT = 0.45;

export function resolveEmailBuilderPanelSheetSnapPoints(panel: Exclude<TEmailBuilderActivePanel, "none">): {
  snapPoints: number[];
  defaultSnapPoint: number;
} {
  const expanded = EMAIL_BUILDER_PANEL_SHEET_EXPANDED_SNAP_POINT;

  switch (panel) {
    case "add-elements":
      return { snapPoints: [0.5, expanded], defaultSnapPoint: 0.5 };
    case "colors":
      return { snapPoints: [0.34], defaultSnapPoint: 0.34 };
    case "templates":
      return { snapPoints: [0.65, expanded], defaultSnapPoint: 0.65 };
    default:
      return { snapPoints: [0.55, expanded], defaultSnapPoint: 0.55 };
  }
}

export function resolveEmailBuilderCustomizeSubSheetSnapPoints(
  subView: "colors" | "general",
): {
  snapPoints: number[];
  defaultSnapPoint: number;
} {
  const expanded = EMAIL_BUILDER_PANEL_SHEET_EXPANDED_SNAP_POINT;

  switch (subView) {
    case "colors":
      return { snapPoints: [0.58, expanded], defaultSnapPoint: 0.58 };
    case "general":
      return { snapPoints: [0.55, expanded], defaultSnapPoint: 0.55 };
    default:
      return { snapPoints: [0.55, expanded], defaultSnapPoint: 0.55 };
  }
}
